import { StyledBroadsiderThreeHudBanner } from './BroadsiderThreeHudBanner.styled';

const BroadsiderThreeHudBanner = () => {
  return (
    <StyledBroadsiderThreeHudBanner>
      <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'start' }}>
        <div className='broadsider-three-banner-logo-container'>
          <img className='broadsider-three-banner-logo' src='/assets/metaverse.svg'/>
        </div>
        <div className='broadsider-three-banner-main-text'>
          <span>Avatar</span>
          <span className='broadsider-three-banner-main-text-selected'>Incubation</span>
          <span className='broadsider-three-banner-secondary-text'>System</span>
        </div>
      </div>
    </StyledBroadsiderThreeHudBanner>
  );
};

export default BroadsiderThreeHudBanner;
